import { TableColumn } from "react-data-table-component";
import { TFunction } from "i18next";
import { Badges, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../service";
import { UserListTableNameProps } from "../../types/users/UserTypes";
import { dynamicImageflags } from "../../service";
import { CountryList } from "../holidays/CountryList";

const UserProfile: React.FC<UserListTableNameProps> = ({ image, name }) => {
  return (
    <div className="product-names my-2">
      <div className="media-left">
        <Image
          className="media-object rounded-circle img-40"
          src={dynamicImage(image)}
          alt="organization"
        />
      </div>
      <P>{name}</P>
    </div>
  );
};

// Utility to map country name to flag code
const countryToFlag = (countryName?: string) => {
  if (!countryName) return undefined;
  const found = CountryList.find((c: any) => c.name === countryName);
  return found && found.image ? `flag-icon/${found.image}` : undefined;
};
const RoleBadge = ({ role }: { role: string }) => (
  <Badges
    color="transparent"
    className={`badge-light-${
      role === "admin"
        ? "danger"
        : role === "employee"
        ? "warning"
        : role === "manager"
        ? "success"
        : "info"
    }`}
  >
    {role}
  </Badges>
);

export const LoginFailureReportTable = (t: TFunction): TableColumn<any>[] => [
  {
    name: t("OrganizationName"),
    cell: (row) => <UserProfile image={row.logo} name={row.organizationname} />,
    sortable: false,
    grow: 2,
  },

  {
    name: t("userName"),
    cell: (row) => <UserProfile image={row.image} name={row.name} />,
    sortable: false,
  },
  {
    name: t("userRole"),
    //   selector: (row) => row.role,
    cell: (row) => <RoleBadge role={row.role} />,
    sortable: false,
  },
  {
    name: t("DateTime"),
    selector: (row) => row.date,
    sortable: true,
  },
  {
    name: t("Origin"),
    cell: (row) => {
      const flagSrc = countryToFlag(row.country);
      return (
        <span className="d-flex align-items-center">
          {flagSrc && (
            <img
              src={dynamicImageflags(flagSrc)}
              alt={row.country}
              style={{ width: 20, height: 15, marginRight: 8 }}
            />
          )}
          {row.country}
        </span>
      );
    },
    sortable: false,
  },
  {
    name: t("Reason"),
    selector: (row) => row.reason,
    sortable: true,
  },
];
